import { Text, Page, Image, View, StyleSheet } from '@react-pdf/renderer'
import BackgroundImage from "@/assets/images/pdf/background.png";
import LogoImage from "@/assets/images/pdf/logo.png";
import { UserCustomerType } from '@/types/apiTypes';

interface StartPageProps {
    projectName: string | null;
    customer: UserCustomerType;
}

const StartPage = ({ projectName, customer }: StartPageProps) => {

    const styles = StyleSheet.create({
        wrapper: { width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" },
        backgroundImageWrapperLandscape: { width: "287mm", height: "200mm", borderRadius: "27px", overflow: "hidden" },
        backgroundImageWrapperPortrait: { height: "287mm", width: "200mm", borderRadius: "27px", overflow: "hidden" },
        logoWrapper: { position: "absolute", bottom: "30mm", right: "6mm" },
        titleWrapper: { position: "absolute", top: "30mm", right: "6mm" },
        landscapeLogo: { width: "200px" },
        landscapeTitle: { textAlign: "center", fontSize: 18, fontFamily: "Chivo" },
        portraitTitle: { textAlign: "center", fontSize: 18, fontFamily: "Chivo", color: "black" },
        portraitTitleWrapper: { position: "absolute", top: "15mm", right: "15mm" },
        landscapeTitleWrapper: { position: "absolute", borderRadius: "27px", display: "flex", gap: 20, alignItems: "center", justifyContent: "center", backgroundColor: "rgba(255,255,255,0.8)", minWidth: "280px", minHeight: "150px", padding: 20 },
    });

    const useCustomBackground = !!customer?.frontpage_image;

    return (
        <Page size="A4" orientation={useCustomBackground ? "portrait" : "landscape"}>
            <View style={styles.wrapper}>
                <View style={useCustomBackground ? styles.backgroundImageWrapperPortrait : styles.backgroundImageWrapperLandscape}>
                    <Image src={useCustomBackground ? customer.frontpage_image : BackgroundImage} style={{ height: "100%" }} />
                </View>
                {!useCustomBackground ? (
                    <View style={styles.landscapeTitleWrapper}>
                        <Image src={customer?.frontpage_logo || LogoImage} style={styles.landscapeLogo} />
                        <Text style={styles.landscapeTitle}>{projectName}</Text>
                    </View>
                ) :
                    <View style={styles.portraitTitleWrapper}>
                        <Text style={styles.portraitTitle}>{projectName}</Text>
                    </View>
                }
            </View>
        </Page>
    )
}


export default StartPage;